<template>
  <div class="content-item">
    <h2 class="heading mb-2">Proof Files</h2>
    <div v-if="previewImage" class="pb-4">
      <div class="mb-4">
        <a-button size="large" class="text-center btn btn-warning font-size-18 mr-4" @click="onDelete"><a-icon type="delete" /></a-button>
      </div>
      <img :src="previewImage" class="w-100" />
    </div>
    <div class="form-upload" v-else>
      <a-upload accept="image/png, image/gif, image/jpeg, image/jpg, image/svg" action list-type="picture-card" :file-list="fileSelected" :before-upload="beforeUpload" @change="handleChange">
        <div v-if="fileSelected.length === 0">
          <div class="ant-upload-text">SELECT IMAGE</div>
        </div>
      </a-upload>
    </div>
    <div v-if="previewImage_1" class="pb-4">
      <div class="mb-4">
        <a-button size="large" class="text-center btn btn-warning font-size-18 mr-4" @click="onDelete1"><a-icon type="delete" /></a-button>
      </div>
      <img :src="previewImage_1" class="w-100" />
    </div>
    <div class="form-upload" v-else>
      <a-upload accept="image/png, image/gif, image/jpeg, image/jpg, image/svg" action list-type="picture-card" :file-list="fileSelected_1" :before-upload="beforeUpload" @change="handleChange_1">
        <div v-if="fileSelected_1.length === 0">
          <div class="ant-upload-text">SELECT IMAGE</div>
        </div>
      </a-upload>
    </div>
  </div>
</template>

<script>
import { empty, getBase64 } from '@/utils';
import Uploader from '@/services/UploadService';

export default {
  name: 'UploadProof',

  data() {
    return {
      fileSelected: [],
      fileSelected_1: [],
      previewImage: null,
      previewImage_1: null,
      percent: 0,
      percent_1: 0,
      isLoading: false,
      isLoading_1: false,
      isUploaded: false,
      isUploaded_1: false,
    };
  },
  watch: {
    percent(value) {
      this.$emit('onLoading', value);
    },
  },
  methods: {
    beforeUpload(file) {
      return false;
    },
    onDelete() {
      this.previewImage = null;
      this.fileSelected = [];
      this.isLoading = false;
      this.percent = 0;
    },
    onDelete1() {
      this.previewImage_1 = null;
      this.fileSelected_1 = [];
      this.isLoading = false;
      this.percent_1 = 0;
    },
    handleChange({ fileList }) {
      if (!empty(fileList)) {
        const image = new Image();
        image.src = URL.createObjectURL(fileList[0].originFileObj);
        image.onload = () => {
          this.fileSelected = fileList;
          this.previewImage = URL.createObjectURL(fileList[0].originFileObj);
        };
      }
    },
    handleChange_1({ fileList }) {
      if (!empty(fileList)) {
        const image = new Image();
        image.src = URL.createObjectURL(fileList[0].originFileObj);
        image.onload = () => {
          this.fileSelected_1 = fileList;
          this.previewImage_1 = URL.createObjectURL(fileList[0].originFileObj);
        };
      }
    },
    async submit() {
      try {
        let front_image = null;
        let back_image = null;
        if (!this.isLoading && !empty(this.fileSelected) && !this.isUploaded) {
          try {
            this.isLoading = true;
            this.percent = 0;
            this.$emit('onLoading', 0);
            const fileContent = this.fileSelected[0];
            let file = {
              contentType: fileContent.type, // you can set it based on the type of image you are uploading like image/png
              fileName: fileContent.name,
              file: await getBase64(fileContent.originFileObj),
            };
            const resp = await new Uploader().uploadImage(file, percent => (this.percent = percent));
            this.isUploaded = true;
            front_image = resp.Location;
          } catch (error) {
            console.log({ error });
            throw error;
          } finally {
            this.isLoading = false;
            // this.percent = 0;
          }
        }
        if (!this.isLoading_1 && !empty(this.fileSelected_1) && !this.isUploaded_1) {
          try {
            this.isLoading_1 = true;
            this.percent_1 = 0;
            this.$emit('onLoading', 0);
            const fileContent = this.fileSelected_1[0];
            let file = {
              contentType: fileContent.type, // you can set it based on the type of image you are uploading like image/png
              fileName: fileContent.name,
              file: await getBase64(fileContent.originFileObj),
            };
            const resp = await new Uploader().uploadImage(file, percent => (this.percent = percent));
            this.isUploaded_1 = true;
            back_image = resp.Location;
            this.isLoading_1 = false;
          } catch (error) {
            console.log({ error });
            throw error;
          } finally {
            this.isLoading_1 = false;
            // this.percent = 0;
          }
        }
        return { front: front_image, back: back_image };
      } catch (error) {
        console.log({ error });
        throw error;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-upload {
  border: 2px dashed #4987c5;
  border-radius: 10px;
  background-color: #f4f7fa;
  padding: 16px;
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  /deep/ .ant-upload {
    border: none;
    background: #4987c5;
    color: #fff;
    margin: 0;
    margin: auto;
    float: none;
    &.ant-upload-select-picture-card {
      width: initial;
      height: initial;
      padding: 0 20px;
    }
  }
}
</style>
